// 操作资源仅用于权限判断。兼容旧接口混入的 BUTTON 和空路径节点，避免注册无效路由。
export function filterMenuResources (resources) {
  if (!Array.isArray(resources)) return []
  return resources.filter(item => {
    if (!item || typeof item.path !== 'string' || !item.path.trim()) return false
    const code = item.code || (item.meta && item.meta.code) || ''
    return item.resourceType !== 'BUTTON' && !String(code).startsWith('oms.action.')
  }).map(item => ({
    ...item,
    meta: { ...item.meta },
    children: filterMenuResources(item.children)
  }))
}
